import classes from 'classes/plugin-manifest';
import connect from 'connect/plugin-manifest';

import { observable } from 'mobx';

import multiDiscipline from 'multi-discipline/plugin-manifest';

import nested from 'nested-property';

import React from 'react';

let plugins = observable.array([classes, connect, multiDiscipline]);

const pluginResolver = <T extends object>(dynamicAreaName: string, props: T = {} as T) => {
  let resultingPlugins = [];
  let key = 0;
  for (let plugin of plugins) {
    let Result = nested.get(plugin, dynamicAreaName);
    if (Result instanceof Array) {
      Result.map((Component, x) => {
        if (React.isValidElement(Component)) {
          resultingPlugins.push(Component);
        } else {
          resultingPlugins.push(<Component key={`${dynamicAreaName}-${key}-${x}`} {...props} />);
        }
      });
    } else if (React.isValidElement(Result)) {
      resultingPlugins.push(Result);
    } else if (Result) {
      resultingPlugins.push(<Result key={`${dynamicAreaName}-${key}-0`} {...props} />);
    }
    key++;
  }
  if (resultingPlugins.length > 0) return resultingPlugins;
  return null;
};

function AddBespokePlugins(bespokePlugins) {
  plugins.push(bespokePlugins);
}

export default pluginResolver;
export { AddBespokePlugins };
